import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Se encacarga de listar tabla clientes paises
//CustomerId: id del cliente a consultar
//UserId: id usuario logueado
export const ObtenerTablaRegistros = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/CustomerRelCountry/Listado/', registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// metodo para crear nuevo registro, recibe:
//const objetoRegistro = {
//    CustomerId: id del cliente 
//    CountryId: id pais seleccionado
//    Type: tipo registro R Residencia / N Nacional
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const CrearNuevoRegistro = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerRelCountry/Guardar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para eliminar un registro, recibe:
//const data = {
//    RelCountryId: id del registro a eliminar (registro cliente/pais),
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const EliminarRegistro = (data) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerRelCountry/Eliminar/", data).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};
